module.exports = "<p>dashboard works!</p>\r\n"